// mallApi.js
import { sendRequest } from "../sendRequest";

const mallApi = {
  async addGoodsToCart(data) {
    return sendRequest("/api/authn/cart/goods/addToCart", {
      method: "POST",
      data,
    });
  },
  async deleteToCart(data) {
    return sendRequest("/api/authn/cart/deleteToCart", {
      method: "POST",
      data,
    });
  },
  async getCartItemsByUserSuid(data) {
    return sendRequest("/api/authn/cart/getCartItemsByUserSuid", {
      method: "POST",
      data,
    });
  },

  async updateCartItemQuantity(data) {
    return sendRequest("/api/authn/cart/updateCartItemQuantity", {
      method: "POST",
      data,
    });
  },

  async processOrder(data) {
    return sendRequest("/api/authn/mall/order/processOrder", {
      method: "POST",
      data,
    });
  },

  async getOrderById(data) {
    return sendRequest("/api/authn/mall/order/getOrderById", {
      method: "POST",
      data,
    });
  },

  async updateOrder(data) {
    return sendRequest("/api/authn/mall/order/updateOrder", {
      method: "POST",
      data,
    });
  },

  async updateShippingInfo(data) {
    return sendRequest("/api/authn/mall/order/updateShippingInfo", {
      method: "POST",
      data,
    });
  },

  async updateOrderAmounts(data) {
    return sendRequest("/api/authn/mall/order/updateOrderAmounts", {
      method: "POST",
      data,
    });
  },

  async updateOrderCancel(data) {
    return sendRequest("/api/authn/mall/order/updateOrderCancel", {
      method: "POST",
      data,
    });
  },

  async copyShippingAddress(data) {
    return sendRequest("/api/authn/mall/order/copyShippingAddress", {
      method: "POST",
      data,
    });
  },

  async fakeApiCallForNicepay(data) {
    return sendRequest("/api/authn/nicepay", {
      method: "POST",
      data,
    });
  },

  async nicepayCancel(data) {
    return sendRequest("/api/authn/nicepay/cancelAuth", {
      method: "POST",
      data,
    });
  },
  async getPaymentById(data) {
    return sendRequest("/api/authn/mall/payment/getPaymentById", {
      method: "POST",
      data,
    });
  },
  async processPayment(data) {
    return sendRequest("/api/authn/mall/payment/processPayment", {
      method: "POST",
      data,
    });
  },

  async updatePaymentStatus(data) {
    return sendRequest("/api/authn/mall/payment/updatePaymentStatus", {
      method: "POST",
      data,
    });
  },
  async updatePaymentCancel(data) {
    return sendRequest("/api/authn/mall/payment/updatePaymentCancel", {
      method: "POST",
      data,
    });
  },

  async updatePaymentFail(data) {
    return sendRequest("/api/authn/mall/payment/updatePaymentFail", {
      method: "POST",
      data,
    });
  },

  // ========== 쿠폰 관련 ==========

  async getCouponById(data) {
    return sendRequest("/api/authn/mall/coupon/getCouponById", {
      method: "POST",
      data,
    });
  },

  // ✅ 새로 추가: 프로모션 쿠폰 등록 (비회원 배포 코드 → 회원가입 후 등록)
  async registerPromotionCoupon(data) {
    return sendRequest("/api/authn/mall/coupon/registerPromotionCoupon", {
      method: "POST",
      data,
    });
  },

  async insertRegisterCoupon(data) {
    return sendRequest("/api/authn/mall/coupon/insertRegisterCoupon", {
      method: "POST",
      data,
    });
  },

  async updateUseCoupon(data) {
    return sendRequest("/api/authn/mall/coupon/updateUseCoupon", {
      method: "POST",
      data,
    });
  },

  async fetchNotification(data) {
    return sendRequest("/api/authn/mall/notification/selectNotifications", {
      method: "POST",
      data,
    });
  },

  async addEstimateToCart(data) {
    return sendRequest("/api/authn/cart/estimate/addToCart", {
      method: "POST",
      data,
    });
  },

  async submitCartApproval(data) {
    return sendRequest("/api/authn/cart-approvals", {
      method: "POST",
      data,
    });
  },

  async getCartApprovalStatuses(cartIds) {
    return sendRequest("/api/authn/cart-approvals/statuses", {
      method: "POST",
      data: cartIds,
    });
  },

  /**
   * 장바구니 삭제/비움 시 해당 카트의 제작 검토 요청을 서버에서 제거 (관리자 대기함 동기화).
   * 백엔드: POST body { userSuid, cartIds: number[] } 검증 후 cart_manufacturing_approval 등 삭제/무효화.
   */
  async cancelCartApprovalsForCarts(data) {
    return sendRequest("/api/authn/cart-approvals/cancel-by-carts", {
      method: "POST",
      data,
    });
  },

  // ========== 배송비 관련 ==========
  async getDomesticShippingFee(data) {
    return sendRequest("/api/public/shipping/domestic-fee", {
      method: "GET",
      params: data, // GET 요청이므로 쿼리 파라미터(?zipcode=...) 형태로 전달
    });
  },
};

export default mallApi;
